<!-- =========================================================================================
  File Name: DataViewSidebar.vue
  Description: Add New Data - Sidebar component
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>
  <vs-sidebar click-not-close position-right parent="body" default-index="1" color="primary" class="add-new-data-sidebar items-no-padding" spacer v-model="isSidebarActiveLocal">
    <div class="mt-6 flex items-center justify-between px-6">
        <h4>{{ Object.entries(this.data).length === 0 ? "ADD NEW" : "EDIT" }} ANNOUNCEMENT</h4>
        <feather-icon icon="XIcon" @click.stop="isSidebarActiveLocal = false" class="cursor-pointer"></feather-icon>
    </div>
    <vs-divider class="mb-0"></vs-divider>

    <component :is="scrollbarTag" class="scroll-area--data-list-add-new" :settings="settings" :key="$vs.rtl">

      <div class="p-6">
      <label class="vs-select--label w-full">Message *</label>
         <vs-textarea label="" v-model="dataMessage" name="message" v-validate="'required'"/>
        <label class="vs-select--label w-full">Select Role</label>
        <v-select  multiple label="fullname" :searchable="false"  :closeOnSelect="true" v-model="dataRole"  :options="roles"  /><br v-if="managerLocation">
        <label v-if="managerLocation" class="vs-select--label inline-flex">Select Manager Locations</label> 
        <label v-if="managerLocation" class="ml-5 vs-select--label" @click="allManagerLocation" style="float:right">Select All</label>
        <v-select v-if="managerLocation" multiple label="name"   :closeOnSelect="true" v-model="dataManagerLocation"  :options="managerslocations" /> <br v-if="userLocation">
        <label v-if="userLocation" class="vs-select--label inline-flex">{{$t('announc.userlable')}}</label> 
        <label v-if="userLocation" class="ml-5 vs-select--label" @click="allUserLocation" style="float:right">Select All</label>
        <v-select v-if="userLocation" multiple label="name"   :closeOnSelect="true" v-model="dataUserLocation"  :options="locations" /> <br  v-if="teacherLocation">
        <label v-if="teacherLocation" class="vs-select--label inline-flex">{{$t('announc.teacherlable')}}</label> 
        <label v-if="teacherLocation" class="ml-5 vs-select--label" @click="allTeacherLocation" style="float:right">Select All</label>
        <v-select v-if="teacherLocation" multiple label="name"   :closeOnSelect="true" v-model="dataTeacherLocation"  :options="teacherslocations" /> <br>
        <!-- <label class="vs-select--label w-full ">{{$t('student.add.users')}}</label>
        <label class=" vs-select--label" @click="allUser" style="float:right">Select All</label>
        <v-select  label="name"  multiple :closeOnSelect="true" v-model="dataUser"  :options="camusers"   /><br> -->
        <label class="vs-select--label" >Expiry Date</label> 
        <datepicker  v-model="dataDate" :open-date="new Date()" :disabledDates="disabledDates" format="MM/dd/yyyy"  ></datepicker>       
        <label class="vs-select--label inline-flex" v-if="dataId">Status</label>        
        <v-select  v-if="dataId" :closeOnSelect="true" v-model="dataStatus"  :options="status" />
      </div>
    </component>

    <div class="flex flex-wrap items-center p-6" slot="footer">
      <vs-button class="mr-6" @click.native="submitData" :disabled="!isFormValid">{{$t('student.add.btn_submit')}}</vs-button>
      <vs-button type="border" color="danger" @click.native="isSidebarActiveLocal = false">{{$t('student.add.btn_cancel')}}</vs-button>
    </div>
  </vs-sidebar>
</template>


<script>
import Datepicker from 'vuejs-datepicker'
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import vSelect from 'vue-select'
import moment from 'moment'
import {
  ALL_MANGER_LOCATIONS,
  ALL_ROLES_QUERY,
  CREATE_ANNOUNCEMENT,
  UPDATE_ANNOUNCEMENT,
  ALL_USERS,
  DROPDOWN_ALL_LOCATIONS,
  ROLE_LOCATIONS,
  MANAGER_LOCATION
} from '@/graphql'
export default {
  props: {
    isSidebarActive: {
      type: Boolean,
      required: true
    },
    data: {
      type: Object,
      default: () => {}
    }
  },
  components: {
    VuePerfectScrollbar,
    'v-select': vSelect,
    Datepicker,
    moment
  },
  data () {
    return {
      dataId:null,
      locations:[],
      managerslocations:'',
      teacherslocations:'',
      status:['Active', 'Inactive'],
      dataStatus:'Active',
      camusers:[],
      roles:[],
      dataManagerLocation:[],
      dataUserLocation:[],
      dataTeacherLocation:[],
      dataMessage:'',
      dataRole:'',
      dataUser:'',
      dataDate:null,
      meRole:'',
      meID:'',
      lng:'',
      settings: { // perfectscrollbar settings
        maxScrollbarLength: 60,
        wheelSpeed: .60
      },
      disabledDates: {
        // to: new Date(Date.now() - 8640000)
        to: new Date(Date.now())
      }
    }
  },
  watch: {
    isSidebarActive (val) {
      if (!val) return
      if (Object.entries(this.data).length === 0) {
        this.initValues()
        this.$validator.reset()
      } else {
        const {id, locations, roles, message, status, users, expiry_date} = JSON.parse(JSON.stringify(this.data))
        this.dataId = id
        this.dataStatus = status
        this.dataRole = roles
        for (let index = 0; index < locations.length; index++) {
          const element = locations[index]
          if (element.pivot.role === 'user') {
            this.dataUserLocation.push(element)
          }
          if (element.pivot.role === 'manager') {
            this.dataManagerLocation.push(element)
          }
          if (element.pivot.role === 'teacher') {
            this.dataTeacherLocation.push(element)
          }
          
        }
        // this.dataUserLocation = locations
        this.dataDate = expiry_date
        this.dataMessage = message
        const getcamusers = []
        for (let j = 0; j < users.length; j++) {
          if (this.validEmail(users[j].email)) {
            users[j].name = `${users[j].fname} ${users[j].lname} - ${users[j].email}`
          } else {
            users[j].name = `${users[j].fname} ${users[j].lname}`
          }
          getcamusers.push(users[j])
        }
        this.dataUser = getcamusers
      }
    }
  },
  computed: {
    isSidebarActiveLocal: {
      get () {
        return this.isSidebarActive
      },
      set (val) {
        if (!val) {
          this.$emit('closeSidebar')
          this.$validator.reset()
          this.initValues()
        }
      }
    },
    isFormValid () {
      return !this.errors.any() && this.dataStatus && this.dataMessage && this.dataDate && (this.dataManagerLocation.length > 0 || this.dataRole.length > 0 || this.dataUserLocation.length > 0 || this.dataTeacherLocation.length > 0)
    },
    scrollbarTag () { return this.$store.getters.scrollbarTag },
    managerLocation () {
      const roles = this.dataRole
      for (let index = 0; index < roles.length; index++) {
        const element = roles[index].name
        if (element === 'manager') {
          return true
        }
      }
    },
    userLocation () {
      const roles = this.dataRole
      for (let index = 0; index < roles.length; index++) {
        const element = roles[index].name
        if (element === 'user' || element === 'contact') {
          return true
        }
      }
    },
    teacherLocation () {
      const roles = this.dataRole
      for (let index = 0; index < roles.length; index++) {
        const element = roles[index].name
        if (element === 'teacher' || element === 'staff') {
          return true
        }
      }
    }
    
  },
  methods: {
    allManagerLocation () {
      if (this.dataManagerLocation.length === this.managerslocations.length) {
        this.dataManagerLocation = []
      } else {
        this.dataManagerLocation = this.managerslocations
      }
    },
    allUserLocation () {
      if (this.dataUserLocation.length === this.locations.length) {
        this.dataUserLocation = []
      } else {
        this.dataUserLocation = this.locations
      }
    },
    allTeacherLocation () {
      if (this.dataTeacherLocation.length === this.teacherslocations.length) {
        this.dataTeacherLocation = []
      } else {
        this.dataTeacherLocation = this.teacherslocations
      }
    },
    StatusSuccess (msg) {
      this.$vs.notify({
        title: 'Announcement',
        text:  msg,
        color: 'success',
        position: 'top-right'
      })
    },
    initValues () {
      this.dataMessage = ''
      this.dataDate = null
      this.dataManagerLocation = []
      this.dataUserLocation = []
      this.dataTeacherLocation = []
      this.dataUser = []
      this.dataRole = []
      this.dataId = null
      this.dataStatus = 'Active'
    },
    validEmail (value) {
      if (value.slice(0, 8) === 'temp-kv-'  &&  /^\d+$/.test(value.slice(9, 18))  &&  value.slice(value.length - 14) === 'kidsvision.com') {
        return false
      } else {
        return true
      }
    },
    submitData () {
      if (this.dataDate) {
        this.dataDate = moment(this.dataDate).format('YYYY-MM-DD')
      }
      const managerlocations = []
      const userlocations = []
      const teacherlocations = []
      const roles = []
      const users = []

      if (this.dataManagerLocation.length > 0  && this.managerLocation) {
        for (let index = 0; index < this.dataManagerLocation.length; index++) {
          managerlocations.push(this.dataManagerLocation[index].id)
        }
      }
      if (this.dataTeacherLocation.length > 0 && this.teacherLocation) {
        for (let index = 0; index < this.dataTeacherLocation.length; index++) {
          teacherlocations.push(this.dataTeacherLocation[index].id)
        }
      }
      if (this.dataUserLocation.length > 0  && this.userLocation) {
        for (let index = 0; index < this.dataUserLocation.length; index++) {
          userlocations.push(this.dataUserLocation[index].id)
        }
      }
      if (this.dataRole.length > 0) {
        for (let index = 0; index < this.dataRole.length; index++) {
          // if(this.dataRole[index].id == 4 || this.dataRole[index].id == 5)
          roles.push(this.dataRole[index].id)
        }
      }
      if (this.dataUser.length > 0) {
        for (let index = 0; index < this.dataUser.length; index++) {
          users.push(this.dataUser[index].id)
        }
      }
      this.$validator.validateAll().then(result => {
        if (result) {
          if (this.dataId !== null && this.dataId >= 0) {
            this.$apollo
              .mutate({
                mutation: UPDATE_ANNOUNCEMENT,
                variables: {
                  id :this.dataId,
                  msg: this.dataMessage,
                  date:this.dataDate,
                  status:this.dataStatus,
                  userlocations,
                  managerlocations,
                  teacherlocations,
                  roles
                }
              })
              .then(response => {
                if (response) {
                  this.StatusSuccess(response.data.updateAnnouncement.message, response.data.updateAnnouncement.color)
                  if (response.data.updateAnnouncement.status == 'Success') {
                    this.$emit('closeSidebar')
                    this.initValues()
                    this.$emit('getdata', true)
                  }

                }
              }).catch(error => {
              })

          } else {
            this.$apollo
              .mutate({
                mutation: CREATE_ANNOUNCEMENT,
                variables: {
                  msg: this.dataMessage,
                  date:this.dataDate,
                  status:this.dataStatus,
                  userlocations,
                  managerlocations,
                  teacherlocations,
                  roles
                }
              })
              .then(response => {
                if (response) {
                  if (response.data.createAnnouncement.status == 'Success') {
                    this.StatusSuccess(response.data.createAnnouncement.message)
                    this.$emit('closeSidebar')
                    this.initValues()
                    this.$emit('getdata', true)
                  }
                }
              }).catch(error => {


              })
          }
        }
      })
    },
    get () {
      let userId= localStorage.getItem('userId');
      let userRole = JSON.parse(localStorage.getItem('userRoles'))
      userRole = userRole[0].name
      this.meRole = userRole
      this.meID = userId
      this.conditionMethod(userRole,userId)
    },
    conditionMethod (role) {
      this.$apollo
        .mutate({
          mutation: ALL_ROLES_QUERY
        })
        .then(response => {
          const roles = []
          for (let index = 0; index < response.data.roles.length; index++) {
            const  element = response.data.roles[index].id
            if (role === 'admin' || role === 'center') {
              if (element != 1) {
                if (this.lng === 'dogs') {
                  if (response.data.roles[index].name === 'user') {
                    response.data.roles[index].name = 'contact'
                  }
                  if (response.data.roles[index].name === 'teacher') {
                    response.data.roles[index].name = 'staff'
                  }
                }
                roles.push(response.data.roles[index])
              }
            }
            if (role === 'manager' || role === 'teacher') {
              if (element == 6) {
                if (this.lng === 'dogs') {
                  if (response.data.roles[index].name === 'user') {
                    response.data.roles[index].name = 'contact'
                  }
                  if (response.data.roles[index].name === 'teacher') {
                    response.data.roles[index].name = 'staff'
                  }
                }
                roles.push(response.data.roles[index])
              }
            }
          }
          roles.forEach(element => {
            element.fullname = element.name.charAt(0).toUpperCase() + element.name.slice(1)
          })
          this.roles = roles
        }) 
    }
  },
  created () {
    this.lng = process.env.VUE_APP_I18N_LOCALE
    this.get()
    const userRoles = JSON.parse(localStorage.getItem('userRoles'))
    let userId= localStorage.getItem('userId');
    let role = userRoles[0]['name']
    if(role=='manager'){
      this.$apollo
        .mutate({
          mutation: MANAGER_LOCATION,
          variables: {
            id: userId
          }
        })
        .then(response => {
              this.locations = response.data.user.managerlocations
        })
    }  
    else{
      this.$apollo
      .mutate({
        mutation: DROPDOWN_ALL_LOCATIONS
      })
      .then(response => {
        this.locations = response.data.dropdownlocations
      })
    }
    this.$apollo
      .mutate({
        mutation: ROLE_LOCATIONS,
        variables: {
          role_id: 7
        }
      })
      .then(response => {
        this.teacherslocations = response.data.roleLocations
      })
    this.$apollo
      .mutate({
        mutation: ROLE_LOCATIONS,
        variables: {
          role_id: 3
        }
      })
      .then(response => {
        this.managerslocations = response.data.roleLocations
      })
  }
}
</script>

<style lang="scss" scoped>
.add-new-data-sidebar {
  ::v-deep .vs-sidebar--background {
    z-index: 52010;
  }

  ::v-deep .vs-sidebar {
    z-index: 52010;
    width: 400px;
    max-width: 90vw;

    .img-upload {
      margin-top: 2rem;

      .con-img-upload {
        padding: 0;
      }

      .con-input-upload {
        width: 100%;
        margin: 0;
      }
    }
  }
}

.scroll-area--data-list-add-new {
    // height: calc(var(--vh, 1vh) * 100 - 4.3rem);
    height: calc(var(--vh, 1vh) * 100 - 16px - 45px - 82px);

    &:not(.ps) {
      overflow-y: auto;
    }

}
</style>
